"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _mixpanelBrowser = _interopRequireDefault(require("mixpanel-browser"));

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(data) {
  // First clean up from last session
  // clear the masquerading properties, or they will persist between sessions
  // even if the user stops masquerading
  _utils.mixpanelWrapper.unregister('Masqueraded By');

  _utils.mixpanelWrapper.unregister('Client Impersonation'); // check if the current user is different from the previous user,
  // if so make sure a new session starts


  if (_mixpanelBrowser.default.get_distinct_id() !== data.user_id) {
    // either a brand new user or a different user in the same browser
    // either way, force a new session
    _utils.mixpanelWrapper.unregister('Last Action');
  }

  var currentProduct = (0, _utils.getCurrentProduct)(data.current_product);

  _utils.mixpanelWrapper.people.set({
    'Last Product Accessed': currentProduct
  });

  _utils.mixpanelWrapper.people.set_once( // "It is not possible to perform overload resolution based on a list of argument types."
  // https://www.typescriptlang.org/docs/handbook/2/conditional-types.html#inferring-within-conditional-types
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  'First Access Date', new Date().toISOString());

  _utils.mixpanelWrapper.people.union({
    'Products Accessed': currentProduct
  });

  _utils.mixpanelWrapper.register({
    'Current Product': currentProduct,
    'Organization Name': data.organization,
    'Organization ID': data.organization_id,
    'User Group Name': data.user_group,
    'User Group ID': data.user_group_id
  });

  if (data.anon) {
    _utils.mixpanelWrapper.people.set({
      'User Type': _constants.USER_TYPES.anonymous
    });

    _utils.mixpanelWrapper.register({
      'User Type': _constants.USER_TYPES.anonymous
    });
  } else {
    _utils.mixpanelWrapper.register({
      Department: data.department || undefined,
      'User Type': _constants.USER_TYPES.registered,
      'Client Impersonation': data.mask ? data.mask.client_impersonation : undefined,
      'Masquerading As': data.mask ? data.mask.email : undefined
    });
  }

  if (data.user_id) {
    _utils.mixpanelWrapper.identify("".concat(data.user_id));
  }
};

exports.default = _default;